import { v4 as uuidv4 } from 'uuid'

import { CONTEXT_NAME, SUPER_PIXEL_NAMESPACE } from './constants'
import type { SendEvent } from './types'

class SuperPixelUtils {
  static async sendEvent({
    ownerUcode,
    instanceId,
    group,
    phase,
    runtimeValues,
    context = CONTEXT_NAME
  }: SendEvent) {
    const injector = window[SUPER_PIXEL_NAMESPACE]

    if (!injector) return

    const setups = await injector.getPixelSetups({
      userCode: ownerUcode,
      context,
      instanceId
    })

    for (const setup of setups) {
      const isEnabled = setup.contextFields[group]?.enabled

      if (isEnabled) {
        const values = { ...runtimeValues, eventId: uuidv4() }
        await injector.sendPixel({
          context,
          instanceId,
          phase,
          runtimeValues: values,
          pixelSetup: setup
        })
      }
    }
  }
}

export default SuperPixelUtils
